import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
// import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
// import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
// import PhoneIphoneOutlinedIcon from '@mui/icons-material/PhoneIphoneOutlined';
//import InstagramIcon from '@mui/icons-material/Instagram';
//import TwitterIcon from '@mui/icons-material/Twitter';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FaFacebook, FaInstagramSquare } from 'react-icons/fa';
//import  from '@mui/icons-material/Facebook';
import { FaArrowCircleUp } from 'react-icons/fa';

export default function Footer() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  window.addEventListener('scroll', toggleVisible);
  const headerImg = '../images/nsurLogo.png';

  return (
    <>
      <div className="container footer-space mt-5">
        <Row>
          <Col md={3}>
            <Link to="/" onClick={scrollToTop}>
              <Navbar.Brand className="brand-footer">
                <span>
                  <img className="img-icon" src={headerImg} alt={headerImg} />
                  {t('app_title')}
                </span>
              </Navbar.Brand>
            </Link>

            <div>
              <p>{t('company_statement')}</p>
            </div>
          </Col>
          <Col md={2}></Col>
          <Col md={3}>
            <h6 className="footer-title d-flex">Location</h6>
            <div className="d-flex my-2 ">
              <i className="fa fa-location-arrow colorInfo p-2"></i>
              Iraq - erbil - 100m road - Opposite Family Mall
            </div>
            <div className="d-flex my-2 ">
              <i className="fa fa-location-arrow colorInfo p-2"></i>
              Iraq - Baghdad - Al-Dalal Street - Near the Ministry of Interior-
              Opposite the Housing Fund
            </div>
          </Col>
          <Col md={2}></Col>
          <Col md={2}>
          <h6 className="footer-title d-flex">Contact Us</h6>
            <div className="d-flex  my-2">
              <i className="fa fa-envelope colorInfo p-2 center"></i>
              info@nsuralbasrah.com
            </div>
            <div className="d-flex p-1 my-1 ">
              <i className="fa fa-phone colorInfo p-1 fa-lg"></i>
              00964 771 452 5656
            </div>
            <div className="d-flex p-1 my-1 ">
              <i className="fa fa-phone colorInfo p-1 fa-lg"></i>
              00964 750 752 5652
            </div>
            {/* <h6 className=" footer-title d-flex">{t('follow_us')}</h6> */}
            <div className="media-footer">
              {/* <a
                href="https://www.facebook.com/profile.php?id=61559232893021"
                target="new_blank"
              >
                <FaFacebook className="media-footer" />
              </a> */}
              {/* <a
                href="https://www.instagram.com/glossy_code?igsh=NjJjaXB2ZjY2ZjFu"
                target="new_blank"
              >
                <FaInstagramSquare className="media-footer" />
              </a> */}
            </div>
          </Col>
        </Row>
      </div>
      <div className="scroll-button">
        <FaArrowCircleUp
          onClick={scrollToTop}
          style={{ display: visible ? 'inline' : 'none' }}
        />
      </div>
      <div className="row-footer">
        <div className="row-line  text-center mt-5">
          <div className="footer-copy w-100">
            © 2024 Copyright: All rights reserved
          </div>
        </div>
      </div>
    </>
  );
}
